<forge-card class="chart" no-padding>
  <forge-toolbar>
    <div slot="start" fxLayout="column">
      <h2 class="forge-typography--heading4">{{ChartTitle}}</h2>
      @if (isLoaded) {
        <truncate-text fxFlex="100" [allowHtml]="true" [mainText]="ChartSubtitle"
          class="forge-typography--subheading1">
        </truncate-text>
      }
    </div>

    <forge-icon-button slot="end" (click)="openSettings()" tabindex="0" class="chart-settings"
      telemetry="Chart settings" aria-haspopup="true" aria-label="chart settings">
      <forge-tooltip>Chart settings</forge-tooltip>
      <forge-icon name="settings"></forge-icon>
    </forge-icon-button>
  </forge-toolbar>

  <div class="metadata-padding">
    @if (isLoaded) {
      <div>
        @if (showChart) {
          <chartjs-container [config]="chartConfig">
          </chartjs-container>
        }
        @if (!showChart) {
          <div>
            Not enough data to display graph
          </div>
        }
        @if (errorMessage) {
          <div class="error-red">
            {{errorMessage}}
          </div>
        }
      </div>
    }

    @if (!isLoaded) {
      <busy-indicator [chart]="true"></busy-indicator>
    }

    @if (isLoaded) {
      <div fxLayout="row" fxLayoutAlign="end center">
        <command-bar [commands]="commands" telemetry="Menu-GenericChart"></command-bar>
      </div>
    }
  </div>
</forge-card>
